// Welches Gerät? Grundlage sind Breite, Höhe und Lage des Fensters – das gilt auf jedem Gerät, auch beim
// Auf- und Zuklappen. Chrome auf Android kann zusätzlich den Modellnamen nennen (User-Agent Client Hints,
// Chrome entscheidet selbst, ob); iPhones nennen keinen. Angezeigt im Setup.
import { t } from './i18n';

export type DeviceKind = 'phone' | 'phone-landscape' | 'fold-open' | 'tablet' | 'desktop';

/** Grenzen wie im CSS (fold.css, board.css): unter 700 px Breite Handy, 700–900 fast quadratisch Klapphandy */
export function deviceKind(w: number, h: number): DeviceKind {
  if (w < 700) return 'phone';
  if (h < 500) return 'phone-landscape';
  if (w <= 900 && w / h >= 0.8) return 'fold-open';
  if (w <= 1100) return 'tablet';
  return 'desktop';
}

const KIND: Record<DeviceKind, string> = {
  phone: 'Handy hochkant',
  'phone-landscape': 'Handy quer',
  'fold-open': 'Klapphandy aufgeklappt',
  tablet: 'Tablet',
  desktop: 'Rechner',
};

export function deviceLabel(model: string | null, w: number, h: number): string {
  const parts = [t(KIND[deviceKind(w, h)]), `${w} × ${h}`];
  return (model ? [model, ...parts] : parts).join(' · ');
}

let model: string | null = null;

/** Modellname, sofern der Browser ihn verrät (nur Chrome & Co. auf Android) */
export async function detectModel(): Promise<string | null> {
  const ua = (navigator as Navigator & { userAgentData?: { getHighEntropyValues(h: string[]): Promise<{ model?: string }> } }).userAgentData;
  try {
    model = (await ua?.getHighEntropyValues(['model']))?.model || null;
  } catch {
    model = null;
  }
  return model;
}

export const currentDevice = () => deviceLabel(model, innerWidth, innerHeight);
